import { Box, Grid, TextField, Typography, Button, Paper } from '@mui/material';
import React, { useState } from 'react';
import TableLoader from './common/contentloader/TableLoader';
import DataGridTable from './common/DataGridTable';

const dummyGitData = [
    {
        id: 1,
      repoName: 'my-awesome-repo',
      branch: 'main',
      commitHash: '1a2b3c4',
      commitMsg: 'Added readme and setup files',
      connectedAt: '2025-04-09 15:30',
      status: 'Connected',
    },
];

const columnList = [
    {
      field: 'repoName',
      headerName: 'Repository Name',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'branch',
      headerName: 'Branch',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'commitHash',
      headerName: 'Last Commit Hash',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'commitMsg',
      headerName: 'Last Commit Message',
      flex: 2,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'connectedAt',
      headerName: 'Connected At',
      flex: 1.5,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <span style={{ color: params.value === 'Connected' ? 'green' : 'red' }}>
          {params.value}
        </span>
      ),
    },
];

const GitRepoConnectionK8s = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Box className="k8s-box">
      <Paper elevation={3} className='k8s-paper'>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Username"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Git Repo URL"
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Git Repo Branch"
                  variant="outlined"
                  required
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Box display="flex" justifyContent="center">
              <Button variant="contained" color="primary">
                Check Connection
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12}>
            {isLoading && <TableLoader />}
            {!isLoading && (
                <DataGridTable
                columns={columnList}
                rows={dummyGitData}
                showTooltip={false}
                showPagination={true}
                />
            )}
            </Grid>

          
        </Grid>
      </Paper>
    </Box>
  );
};

export default GitRepoConnectionK8s;
